import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DigitalAssistantService } from '../../../digital-assistant.service';

@Component({
  selector: 'miq-chat-bot-header',
  templateUrl: './chat-bot-header.component.html',
  styleUrls: ['./chat-bot-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatBotHeaderComponent {
  @Output()
  emitToggleMinimize = new EventEmitter();
  @Output() emitNewSession = new EventEmitter<void>();
  @Output() emitWindowSize = new EventEmitter<boolean>();
  @Output() emitCloseChat = new EventEmitter<void>();
  @Input() showBackBtn = false;
  @Input() showMenuBtn = false;
  @Input() windowSizeIncreased = true;
  @Input() showTitle = true;
  @Input() pageTitle = '';
  @Input() isInprogress = false;
  @Input() showCloseBtn = true;

  constructor(private chatBotService: DigitalAssistantService) {}

  toggleWindowSize(): void {
    this.windowSizeIncreased = !this.windowSizeIncreased; // Ensure the property is toggled
    this.emitWindowSize.emit(this.windowSizeIncreased); // Emit the updated value
  }

  newSession(): void {
    this.emitNewSession.emit();
  }

  toggleLeftPanel(): void {
    this.chatBotService.isLeftPanelOpen.update(prev => !prev);
    this.chatBotService.trackUserAction('Chat history panel toggled');
  }

  toggleBackBtn(): void {
    this.chatBotService.isPromptsPanelOpen.update(prev => !prev);
    this.chatBotService.trackUserAction('Pre-defined Prompts panel closed (View All Prompts)');
  }

  closeChat(): void {
    this.emitCloseChat.emit();
  }
}
